(function () {
  'use strict';

  const SEE_MORE_LIMIT = 5;

  function initVariantFilters() {
    const grid = document.getElementById('HousiousProductGrid');
    const groupsContainer = document.getElementById('DynamicVariantFilterGroups');

    if (!grid || !groupsContainer) return;

    // Never initialise twice (section reloads in the theme editor)
    if (grid.dataset.variantFiltersReady === 'true') return;
    grid.dataset.variantFiltersReady = 'true';

    const filterRoot = document.getElementById('DynamicVariantFilters');
    const countElement = document.getElementById('LoadedProductsCount');
    const selected = new Map();

    /* ------------------------------------------------------------------
       PERF: JSON.parse of every card's options/variants used to run on
       every rebuild AND every filter click. Now each card is parsed once
       and cached against its element.
       ------------------------------------------------------------------ */
    const cache = new WeakMap();

    function parseProduct(element) {
      let data = cache.get(element);
      if (data) return data;

      try {
        data = {
          element,
          options: JSON.parse(element.dataset.productOptions || '[]'),
          variants: JSON.parse(element.dataset.productVariants || '[]')
        };
      } catch (error) {
        data = { element, options: [], variants: [] };
      }

      cache.set(element, data);
      return data;
    }

    function getProducts() {
      return Array.from(
        grid.querySelectorAll('.collection-variant-product')
      ).map(parseProduct);
    }

    function buildFilters(products) {
      const optionGroups = new Map();

      products.forEach((product) => {
        product.options.forEach((optionName, index) => {
          if (!optionGroups.has(optionName)) {
            optionGroups.set(optionName, new Map());
          }

          const values = optionGroups.get(optionName);

          product.variants.forEach((variant) => {
            const value = variant.options ? variant.options[index] : null;

            if (value == null || value === '') return;

            if (!values.has(value)) {
              values.set(value, new Set());
            }

            values.get(value).add(product.element);
          });
        });
      });

      // Build everything off-DOM, then swap once (one reflow, not many)
      const fragment = document.createDocumentFragment();

      if (optionGroups.size === 0) {
        groupsContainer.replaceChildren();
        if (filterRoot) filterRoot.hidden = true;
        return;
      }

      if (filterRoot) filterRoot.hidden = false;

      optionGroups.forEach((values, optionName) => {
        const block = document.createElement('div');
        block.className = 'filter-group-block dynamic-variant-option';

        const heading = document.createElement('h4');
        heading.className = 'filter-group-title';
        heading.textContent = optionName;

        const list = document.createElement('ul');
        list.className = 'filter-checkbox-list';

        const selectedValues = selected.get(optionName) || new Set();

        let hasCheckedInExtra = false;
        let position = 0;

        values.forEach((productSet, value) => {
          position++;
          if (position > SEE_MORE_LIMIT && selectedValues.has(value)) {
            hasCheckedInExtra = true;
          }
        });

        const extraItems = [];
        position = 0;

        values.forEach((productSet, value) => {
          position++;

          const item = document.createElement('li');
          const label = document.createElement('label');
          label.className = 'filter-checkbox-label';

          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.className = 'filter-checkbox-input js-variant-filter';
          checkbox.dataset.option = optionName;
          checkbox.value = value;
          checkbox.checked = selectedValues.has(value);

          const text = document.createElement('span');
          text.className = 'custom-checkbox-text';
          text.textContent = value;

          const count = document.createElement('span');
          count.className = 'filter-item-count';
          count.textContent = `(${productSet.size})`;

          label.append(checkbox, text, count);
          item.append(label);

          if (position > SEE_MORE_LIMIT) {
            item.style.display = hasCheckedInExtra ? '' : 'none';
            item.classList.add('hidden-variant-item');
            extraItems.push(item);
          }

          list.append(item);
        });

        block.append(heading, list);

        if (values.size > SEE_MORE_LIMIT) {
          const remaining = values.size - SEE_MORE_LIMIT;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'view-more-link';
          btn.dataset.expanded = hasCheckedInExtra ? 'true' : 'false';
          btn.style.cssText =
            'background: none; border: none; color: #721033; padding: 0; font-weight: 600; cursor: pointer; margin-top: 10px;';
          btn.textContent = hasCheckedInExtra
            ? '- View Less'
            : `+ View More (${remaining})`;

          btn.addEventListener('click', () => {
            const isExpanded = btn.dataset.expanded === 'true';
            btn.dataset.expanded = isExpanded ? 'false' : 'true';
            btn.textContent = isExpanded
              ? `+ View More (${remaining})`
              : '- View Less';

            extraItems.forEach((li) => {
              li.style.display = isExpanded ? 'none' : '';
            });
          });

          block.append(btn);
        }

        fragment.append(block);
      });

      groupsContainer.replaceChildren(fragment);
    }

    function applyFilters(products) {
      let visibleCount = 0;

      products.forEach((product) => {
        let matches = true;

        selected.forEach((selectedValues, optionName) => {
          if (!matches || selectedValues.size === 0) return;

          const optionIndex = product.options.indexOf(optionName);

          if (optionIndex === -1) {
            matches = false;
            return;
          }

          const matchingVariant = product.variants.some((variant) => {
            const value = variant.options ? variant.options[optionIndex] : null;
            return selectedValues.has(value);
          });

          if (!matchingVariant) matches = false;
        });

        // Only touch the DOM when the state really changes
        if (product.element.hidden === matches) {
          product.element.hidden = !matches;
        }

        if (matches) visibleCount++;
      });

      if (countElement) {
        countElement.textContent = visibleCount;
      }
    }

    /* ------------------------------------------------------------------
       Rebuild only when the SET of products changed (new page loaded).
       Re-ordering cards or re-applying the same products no longer
       rebuilds the whole sidebar.
       ------------------------------------------------------------------ */
    let lastSignature = null;

    function refresh() {
      const products = getProducts();

      const signature = products
        .map((product) => product.element.dataset.productId || '')
        .sort()
        .join(',');

      if (signature !== lastSignature) {
        lastSignature = signature;
        buildFilters(products);
      }

      applyFilters(products);
    }

    groupsContainer.addEventListener('change', (event) => {
      const checkbox = event.target.closest('.js-variant-filter');
      if (!checkbox) return;

      const optionName = checkbox.dataset.option;

      if (!selected.has(optionName)) {
        selected.set(optionName, new Set());
      }

      const values = selected.get(optionName);

      if (checkbox.checked) {
        values.add(checkbox.value);
      } else {
        values.delete(checkbox.value);
      }

      if (values.size === 0) {
        selected.delete(optionName);
      }

      applyFilters(getProducts());
    });

    const clearAll = document.getElementById('ClearAllFilters');

    if (clearAll) {
      clearAll.addEventListener('click', () => {
        selected.clear();
      });
    }

    refresh();

    /* ------------------------------------------------------------------
       PERF FIX: the observer used to watch the WHOLE subtree, so any
       change inside any product card (slider, quick-add button text,
       modal, image swap) rebuilt the entire filter sidebar. Now it only
       watches the grid's direct children (products added/removed), and
       runs when the browser is idle so it never blocks scrolling.
       ------------------------------------------------------------------ */
    const whenIdle =
      window.requestIdleCallback ||
      function (callback) {
        return window.setTimeout(callback, 1);
      };

    let rebuildTimeout;

    const observer = new MutationObserver(() => {
      clearTimeout(rebuildTimeout);

      rebuildTimeout = setTimeout(() => {
        whenIdle(refresh);
      }, 150);
    });

    observer.observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantFilters);
  } else {
    initVariantFilters();
  }
})();